import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const CollapsiblePanel = (props) => {
  const {
    title,
    heading,
    children,
    className = '',
  } = props;
  const resolvedTitle = title || heading;
  const resolvedDefaultOpen = props.defaultOpen ?? props.defaultOpen ?? false;
  const resolvedTrailing = props.trailing ?? props.trailing ?? null;
  const [open, setOpen] = useState(resolvedDefaultOpen);

  return (
    <div className={`bg-white rounded-xl border border-gray-100 mb-4 md:mb-6 ${className}`}>
      <div className="px-3 sm:px-4 md:px-5 py-2.5 sm:py-3">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <button
              type="button"
              onClick={() => setOpen((value) => !value)}
              className="min-w-0 flex-1 text-left"
            >
              <h2 className="text-sm sm:text-base font-semibold text-gray-800 min-w-0 break-words leading-snug">
                {resolvedTitle}
              </h2>
            </button>
            <button
              type="button"
              onClick={() => setOpen((value) => !value)}
              className="p-1 rounded-lg text-gray-500 hover:bg-gray-50 shrink-0 sm:hidden"
              aria-expanded={open}
              aria-label={open ? 'Collapse section' : 'Expand section'}
            >
              {open ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
            </button>
          </div>
          <div className="flex items-start sm:items-center gap-2 min-w-0 w-full sm:w-auto sm:max-w-[72%] sm:justify-end">
            {resolvedTrailing ? (
              <div className="min-w-0 flex-1 w-full sm:flex-initial sm:w-auto">{resolvedTrailing}</div>
            ) : null}
            <button
              type="button"
              onClick={() => setOpen((value) => !value)}
              className="hidden sm:inline-flex p-1 rounded-lg text-gray-500 hover:bg-gray-50 shrink-0"
              aria-expanded={open}
              aria-label={open ? 'Collapse section' : 'Expand section'}
            >
              {open ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>
      {open && <div className="px-3 sm:px-4 md:px-5 pb-3 sm:pb-4 md:pb-5">{children}</div>}
    </div>
  );
};

export default CollapsiblePanel;
